
<div
  class="amplify-authenticator"
  *ngIf="_show"
  data-test="sign-up-section"
  >
  <div class="amplify-form-body" data-test="sign-up-body-section">
    <div class="amplify-form-header" data-test="sign-up-header-section">
      {{ this.amplifyService.i18n().get(this.header) }}</div>
    <ion-list lines="none">
      <ion-item lines="none" *ngFor="let field of signUpFields">
        <ion-label class="amplify-input-label"
        position="stacked"
        *ngIf="field.key !== 'phone_number'"
        >
          {{ this.amplifyService.i18n().get(field.label) }}
          <span *ngIf="field.required">*</span>
        </ion-label>
        <ion-input
          [ngClass]="{'amplify-input-invalid ': field.invalid}"
          *ngIf="field.key !== 'phone_number'"
          #{{field.key}}
          type="text"
          class="amplify-form-input"
          type={{field.type}}
          [placeholder]="this.amplifyService.i18n().get(field.label)"
          (keyup)="setProp($event.target)"
          name={{field.key}}
          data-test="sign-up-non-phone-number-input"
        ></ion-input>
        <ion-content *ngIf="field.key === 'phone_number'" class="amplify-phone-ion-content">
          <amplify-auth-phone-field-ionic
            [label]="field.label"
            [required]="field.required"
            [placeholder]="field.placeholder"
            [defaultCountryCode]="country_code"
            (phoneFieldChanged)="onPhoneFieldChanged($event)"
          ></amplify-auth-phone-field-ionic>
        </ion-content>
      </ion-item>
    </ion-list>
    <div class="amplify-form-actions">
      <div class="amplify-form-row">
        <ion-button expand="block" color="primary"
          (click)="onSignUp()"
          data-test="sign-up-create-account-button"
        >{{ this.amplifyService.i18n().get('Create Account') }}</ion-button>
      </div>
      <div class="amplify-form-row">
        <div class="amplify-form-signup">
          {{ this.amplifyService.i18n().get('Have an account?') }}
          <a class="amplify-form-link" (click)="onSignIn()" data-test="sign-up-sign-in-button">
            {{ this.amplifyService.i18n().get('Sign In') }}
          </a>
        </div>
        <div class="amplify-form-signup" *ngIf="!shouldHide('SignUp')">
          {{ this.amplifyService.i18n().get('Have a code?') }}
          <a
            class="amplify-form-link"
            (click)="onConfirmSignUp()"
            data-test="sign-up-confirm-button"
            >
            {{ this.amplifyService.i18n().get('Confirm') }}
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="amplify-alert" *ngIf="errorMessage">
    <div class="amplify-alert-body">
      <span class="amplify-alert-icon">&#9888;</span>
      <div class="amplify-alert-message">{{ this.amplifyService.i18n().get(errorMessage) }}</div>
      <a class="amplify-alert-close" (click)="onAlertClose()">&times;</a>
    </div>
  </div>
</div>
